import { createReducer } from '@reduxjs/toolkit';
import { switchAccountSuccess } from 'store/account/actions';
import { oc } from 'ts-optchain';
import * as actions from '../actions';
import { TriageResults } from '../types';

export interface TriageGyantResultsState {
  isFetching: boolean;
  error: null | Error;
  data: TriageResults | {};
  origin: null | string;
}

export const triageGyantResultsInitialState: TriageGyantResultsState = {
  isFetching: false,
  error: null,
  data: {},
  origin: null
};

const triageGyantResultsReducer = createReducer(triageGyantResultsInitialState, {
  [actions.TRIAGE_GYANT_RESULTS]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.TRIAGE_GYANT_RESULTS_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data = oc(action).payload.data.case({});
  },
  [actions.TRIAGE_GYANT_RESULTS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.data = {};
    state.error = action.error;
  },
  [actions.SET_TRIAGE_ORIGIN]: (state, action) => {
    state.origin = action.payload;
  },
  [actions.RESET_TRIAGE_RESULTS_DATA]: state => {
    state.isFetching = false;
    state.data = {};
    state.error = null;
  },
  [switchAccountSuccess.type]: () => triageGyantResultsInitialState
});

export default triageGyantResultsReducer;
